// Copyright (c) 2016 Deere & Company

import LanguageSettings from './components/language-settings';
import actionCreators from '../shared/action-creators';
import {connect} from 'react-redux';
import {handleOnPageLeave} from '../shared/services/handle-on-page-leave';

const getStateToBindToContainerProps = state => ({
    ...state.user.preferences,
    userLanguageSettings: state.user.details.settings.language
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    actions: {
        ...dispatchProps,
        handleOnPageLeave
    },
    ...stateProps
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LanguageSettings);



// WEBPACK FOOTER //
// ./src/user/language-settings/state-connector.js